module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGca4d46e6bebd85a82a4edb60bf79b4c7.ca4d46e6.png";